export default {
  props: {
    togglerClass: String,
    togglerTag: {
      type: String,
      default: 'button',
    },
    boxClass: String,
    contentClass: String,
    iconName: {
      type: String,
      default: 'PlusIcon',
    },
  },
};
